module.exports = __webpack_public_path__ + "img/254.problem_seller.201d4f21.svg";